import template from './is-legal-address-provided.jade';
import items from '../../../enums/legal-address-provided';

export default angular
  .module('cian.addForm.aboutObjectIsLegalAddressProvided', ['cian.addForm.fieldTypeDropdown'])
  .directive('cianAfAboutObjectIsLegalAddressProvided', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      function () {
        this.items = items;
      },
    ],
    controllerAs: 'isLegalAddressProvidedCtrl',
    template,
  })).name;
